export default __webpack_public_path__ + "static/media/master_card.8b68066f.svg";